/* eslint-disable import/max-dependencies */
import environment from "environment";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserInfo as getUserInfoSelector } from "@fas/cpa-state-manager/services/selectors/userInfo";

import { useHandleRequest } from "@fas/cpa-state-manager/redux/hooks";
import { setLoading } from "@fas/cpa-state-manager/redux/actions/loading";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";
import { setUserInfo } from "@fas/cpa-state-manager/redux/actions/userInfo";
import { USER_INFO } from "@fas/cpa-state-manager/redux/constants";
import { getUserInfo } from "../../services/deprecatedApi";

export type DefaultUserInfoState = {
  id: string;
  name: string;
  avatarUrl: string;
  email: string;
};
export type UseUserInfoHook = {
  id: string;
  name: string;
  avatarUrl: string;
  email: string;
  isLoading: boolean;
  onViewClick: () => unknown;
};

export const useUserInfo: () => UseUserInfoHook = () => {
  const userInfo = useSelector(getUserInfoSelector) as DefaultUserInfoState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFetched = useSelector((state) =>
    getLoadingState(state, `${USER_INFO}-fetched`)
  );
  const { isLoading, changeLoading, onFail, onFinally } =
    useHandleRequest(USER_INFO);
  useEffect(() => {
    changeLoading(true);
    getUserInfo()
      .then((response) => {
        const {
          id = "",
          firstName = "",
          lastName = "",
          email = "",
          photo: avatarUrl,
        } = response.data;
        dispatch(setLoading(`${USER_INFO}-fetched`, true));
        dispatch(
          setUserInfo({
            id,
            avatarUrl,
            name: `${firstName} ${lastName}`,
            email,
          })
        );
      })
      .catch(onFail)
      .finally(onFinally);
  }, []);

  const onViewClick = () => navigate(environment.links.userInfo);

  return {
    ...userInfo,
    onViewClick,
    isLoading: isLoading && !isFetched,
  };
};
